import React from 'react';
import './multiliner_spinner.scss';

const MultiLine_Spinner = () => {
	return (
		<>
			<div class="triple-spinner"></div>
		</>
	);
};

export default MultiLine_Spinner;
